// src/utils/authUtils.js
import { jwtDecode } from 'jwt-decode'; // Use named import

export const isTokenValid = (token) => {
  if (!token) return false;
  try {
    const { exp } = jwtDecode(token); // Extract the expiration time
    const currentTime = Date.now() / 1000; // Current time in seconds
    return exp > currentTime; // Check if the token is still valid
  } catch (err) {
    return false; // If decoding fails, treat as invalid
  }
};
